import { AVAILABLE } from '../../EventHeader/BookNow/helpers/availabilityTypes';
import { getAvailableTicketPrices } from '../../EventHeader/BookNow/helpers';

import getTicketPrices from './getTicketPrices';

export default (race, availabilityType) => {
  const ticketPrices =
    availabilityType === AVAILABLE ? getAvailableTicketPrices([race]) : getTicketPrices([race]);
  return ticketPrices
    ? `${ticketPrices.fromFormatted}${
        ticketPrices.toFormatted ? `–${ticketPrices.toFormatted}` : ''
      }`
    : null;
};



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/helpers/getPriceLabel.js